/**
 * Product detail page body strings.
 *
 * Same accuracy rules as the rest of the dictionary: never translate product
 * or ingredient names, doses, units, prices, pack sizes, certification names
 * or study references, and never strengthen a claim.
 */

export const pdpBody = {
  en: {
    "pdp.section.ingredients": "Ingredients",
    "pdp.section.howToUse": "How to use",
    "pdp.section.absorption": "Absorption",
    "pdp.section.faq": "Frequently asked questions",
    "pdp.section.reviews": "Reviews",
    "pdp.section.studiedEffects": "Studied effects",
  },
} as const;
